var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return ((_vm.slotIcon && !_vm.value) || _vm.value.indexOf('base64') > 0)?_c('div',{staticClass:"linear-gradient"}):(_vm.isVideo)?_c('Video',{attrs:{"src":_vm.changeUrl(_vm.value),"width":"100%","height":"100%"}}):_c('img',{staticClass:"z-image",style:({ 'object-fit': _vm.isFullHeight ? 'contain' : '' }),attrs:{"src":_vm.reailVal}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-734fdedb","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ZImage.vue
// module id = null
// module chunks = 